import { Environment } from '../app/core/models/environment.model';

import { appConfig } from './app-config';

export const environment: Environment = {
  production: false,
  ...appConfig,
};
